/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LoginRequestDto,
  LoginResponseDto,
  MeResponseDto,
  UpdateMeRequestDto,
} from '../models/index';
import {
    LoginRequestDtoFromJSON,
    LoginRequestDtoToJSON,
    LoginResponseDtoFromJSON,
    LoginResponseDtoToJSON,
    MeResponseDtoFromJSON,
    MeResponseDtoToJSON,
    UpdateMeRequestDtoFromJSON,
    UpdateMeRequestDtoToJSON,
} from '../models/index';

export interface LoginControllerLoginRequest {
    loginRequestDto: LoginRequestDto;
}

export interface MeControllerUpdateCurrentUserRequest {
    updateMeRequestDto: UpdateMeRequestDto;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * User login
     */
    async loginControllerLoginRaw(requestParameters: LoginControllerLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponseDto>> {
        if (requestParameters['loginRequestDto'] == null) {
            throw new runtime.RequiredError(
                'loginRequestDto',
                'Required parameter "loginRequestDto" was null or undefined when calling loginControllerLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/login`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestDtoToJSON(requestParameters['loginRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseDtoFromJSON(jsonValue));
    }

    /**
     * User login
     */
    async loginControllerLogin(requestParameters: LoginControllerLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponseDto> {
        const response = await this.loginControllerLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * User logout
     */
    async logoutControllerLogoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/logout`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * User logout
     */
    async logoutControllerLogout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logoutControllerLogoutRaw(initOverrides);
    }

    /**
     * Get current authenticated user
     */
    async meControllerGetCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/me`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get current authenticated user
     */
    async meControllerGetCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeResponseDto> {
        const response = await this.meControllerGetCurrentUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update current authenticated user
     */
    async meControllerUpdateCurrentUserRaw(requestParameters: MeControllerUpdateCurrentUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateMeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateMeRequestDto',
                'Required parameter "updateMeRequestDto" was null or undefined when calling meControllerUpdateCurrentUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/auth/me`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMeRequestDtoToJSON(requestParameters['updateMeRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update current authenticated user
     */
    async meControllerUpdateCurrentUser(requestParameters: MeControllerUpdateCurrentUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.meControllerUpdateCurrentUserRaw(requestParameters, initOverrides);
    }

}
